import { isStandaloneApp } from "../../pwa/browserDisplayMode";
import { readSavedVersionPreference } from "./versionPreferences";

// Même lecture que readStoredUser / userIdFrom (browserAdapters.js), sans leurs
// dépendances : ce module est évalué par le bundle principal.
const storedUserOf = (storage) => {
  try {
    const value = JSON.parse(storage?.getItem?.("userData") || "{}");
    return value && typeof value === "object" ? value : {};
  } catch (_) {
    return {};
  }
};
const idOf = (user) => {
  const candidate = user?.userId || user?.uid || user?.id || user?.email;
  return typeof candidate === "string" && candidate.trim() ? candidate.trim() : null;
};

/**
 * Une adresse Classique ouverte par une personne qui a choisi la Nouvelle
 * interface sera ramenée en V2 par la restauration de version
 * (useWelfareNavigation), montée aujourd'hui par la barre latérale Classique —
 * donc APRÈS la première peinture de la V1. Ce pronostic synchrone (profil et
 * choix rangés dans ce navigateur, même périmètre que cette restauration :
 * staff AKONGO) permet d'afficher le squelette V2 pendant qu'elle décide.
 */
export const expectsLegacyVersionRestore = (storage = typeof window !== "undefined" ? window.localStorage : null) => {
  if (isStandaloneApp()) return true;
  const user = storedUserOf(storage);
  const userId = idOf(user);
  return Boolean(userId && user.akongoStaff === true && readSavedVersionPreference(storage, userId) === "v2");
};
